/**
 * @generated SignedSource<<bbec80b8d7ffb4e36b6143c20c7fdacc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment$data = {
  readonly __typename: "Content";
  readonly id: string | null | undefined;
  readonly status: string | null | undefined;
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment";
};
export type ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment$key = {
  readonly " $data"?: ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};

(node as any).hash = "24af67d646910e1784019b6a037f34e4";

export default node;
